<template lang="pug">
  v-flex.pt-2.px-3.mt-2(v-if="config")
    v-dialog(width="50%" height="80%" v-model="confirmDelete" persistent)
      v-card
        v-card-title.create-conf
          v-layout
            v-flex.xs10.offset-xs1
              .headline.text-xs-center.white--text.font-style-Roboto.font-weight-bold Suppression du fichier
        v-card-text
          v-layout.confirm-delete-container
            p.confirm-text Etes-vous sûr de vouloir supprimer ce fichier ? Cette action sera irréversible.
            div
              v-btn.grey--text(@click="confirmDelete = false") Annuler
              v-btn(color="#e7523e" dark @click="deleteFile") Supprimer

    .title Configuration
    v-layout.column.margin
      v-flex.pt-2.px-3
        v-layout.column
          v-layout
            label.v-label.grey--text.invert-title.pr-2 Afficher les zones
            v-checkbox.checkbox.mt-0.ml-4.pl-2(
              :input-value="config.boundary?config.boundary.state:false"
              color="primary"
              @change="activateOrDeactivateBoundaries"
            )

    .title Dépôt du fichier
    v-flex.pt-2.px-3
      v-layout.column.margin.file.drop-container(
        @dragover.prevent="dropped = true"
        @dragleave.prevent="dropped = false"
        @drop.prevent="dropFile"
        :class="{'has-file': !fileIsUploaded}"
      )
        div.upload
          input(
            type="file"
            ref="input"
            @change="addFile"
          )
          div.dropZone
            p.error-message(v-if="error") {{ error }}
            p.success-message(v-if="success") {{ success }}
            svg.uploadIcon(xmlns="http://www.w3.org/2000/svg" viewBox="8 10 80 80")
              path.file(d="M30.7,13h24.6C59.5,13,73,26.8,73,30.9v49.6c-0.1,4.2-3.5,7.6-7.7,7.5H30.7c-4.2,0.1-7.6-3.3-7.7-7.5v-60 C23.1,16.3,26.5,12.9,30.7,13z")
              path.lines(d="M34.5,48.5h27 M34.5,56.5h27 M34.5,64.5h27 M55,11.3h17c1.5,0,2.8,1.2,2.8,2.8v17c0,1.5-1.2,2.8-2.8,2.8H55 c-1.5,0-2.8-1.2-2.8-2.8V14C52.3,12.5,53.5,11.3,55,11.3z")
            p(
              v-if="fileIsUploaded"
            ) {{ "Déposez votre fichier (GeoJSON, GPX ou KML) ou cliquez ici pour l'importer (max. 15Mo)." }}
            span.msg(v-else)
              p {{ file.name || this.name }} ({{ formatFileSize(file.size || this.size) }})
              svg.delete(
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                @click="confirmDelete=true"
              )
                path(d="M53.21 467c1.562 24.84 23.02 45 47.9 45h245.8c24.88 0 46.33-20.16 47.9-45L416 128H32L53.21 467zM432 32H320l-11.58-23.16c-2.709-5.42-8.25-8.844-14.31-8.844H153.9c-6.061 0-11.6 3.424-14.31 8.844L128 32H16c-8.836 0-16 7.162-16 16V80c0 8.836 7.164 16 16 16h416c8.838 0 16-7.164 16-16V48C448 39.16 440.8 32 432 32z")

    .title Configuration des couleurs
    v-layout.column.margin
      v-flex.pt-2.px-3
        v-layout.column.mb-4
          .grey--text.subheading Couleur du tracé
          v-layout
            v-flex.xs6
              v-select.pt-0.mt-0.mb-2(
                hide-details
                item-text="label"
                item-value="value"
                :items="colorChoices"
                :value="config.boundary?getKeyFrom(config.boundary.line_color):'custom'"
                @change="value => updateColor('line', getColorFrom(value))"
              )
            v-flex.xs4.offset-xs1
              rc-color-picker(
                popup="top"
                :color="lineColor"
                @changeColor="value => updateColor('line', value)"
              )
          v-slider(
            thumb-label
            :min="0" :max="5" :step="0.2"
            label="Epaisseur (en px)"
            :value="lineWidth"
            @change="updateLineWidth"
          )
        v-layout.column
          .grey--text.subheading Couleur de remplissage
          v-layout
            v-flex.xs6
              v-select.pt-0.mt-0.mb-2(
                hide-details
                item-text="label"
                item-value="value"
                :items="colorChoices"
                :value="config.boundary?getKeyFrom(config.boundary.fill_color):'custom'"
                @change="value => updateColor('fill', getColorFrom(value))"
              )
            v-flex.xs4.offset-xs1
              rc-color-picker(
                popup="top"
                :color="fillColor"
                @changeColor="value => updateColor('fill', value)"
              )
          v-layout
            label.v-label.grey--text.invert-title Inverser le remplissage
            v-checkbox.checkbox(
              :input-value="config.boundary?config.boundary.fill_reversed:false"
              color="primary"
              @change="reverseFill"
            )
          v-slider.mb-5(
            thumb-label
            :min="0" :max="100" :step="10"
            label="Opacité (en %)"
            :value="opacity"
            @change="updateOpacity"
          )
</template>

<script>
import RcColorPicker from '@/components/RcColorPicker.vue';
import mixin from '@/mixins/Rc.mixin.vue';
import api from '@/api/apiTmaps/apiGeometry';

export default {
  components: {
    RcColorPicker,
  },
  mixins: [mixin],
  props: {
    config: Object,
  },
  data() {
    return {
      error: '',
      success: '',
      file: null,
      dropped: false,
      geometryId: null,
      confirmDelete: false,
      size: null,
    };
  },
  mounted() {
    this.geometryId = this.config.boundary.conf_id;
    if (this.geometryId) {
      api.getGeojsonInfos(this.geometryId).then(
        // Success
        (response) => {
          this.file = '';
          this.name = response.request.response.name || 'file.geojson';
          this.size = response.request.response.size;
        },
        // Error
        () => {
          this.error = 'Récupération du fichier impossible ! Veuillez réessayer ultérieurement.';
        },
      );
    }
  },
  computed: {
    lineColor() {
      // eslint-disable-next-line operator-linebreak
      return (this.config.boundary && this.config.boundary.line_color) ?
        this.config.boundary.line_color : this.defaultColor;
    },
    lineWidth() {
      // eslint-disable-next-line operator-linebreak
      return (this.config.boundary && this.config.boundary.line_width != null) ?
        this.config.boundary.line_width : 1;
    },
    fillColor() {
      // eslint-disable-next-line operator-linebreak
      return (this.config.boundary && this.config.boundary.fill_color) ?
        this.config.boundary.fill_color : '#000000';
    },
    opacity() {
      // eslint-disable-next-line operator-linebreak
      return (this.config.boundary && this.config.boundary.fill_opacity != null) ?
        this.config.boundary.fill_opacity * 100 : 20;
    },
    fileIsUploaded() {
      return this.file == null;
    },
  },
  methods: {
    activateOrDeactivateBoundaries() {
      this.config.boundary.state = !(this.config.boundary && this.config.boundary.state);
      this.$emit('changed', this.filterConfig(this.config));
    },
    updateColor(type, value) {
      // Necessary for lineColor() and fillColor() to recalculate
      const boundary = JSON.parse(JSON.stringify(this.config.boundary));
      // eslint-disable-next-line
      switch(type) {
        case 'line':
          boundary.line_color = value;
          break;
        case 'fill':
          boundary.fill_color = value;
          break;
      }
      this.$set(this.config, 'boundary', boundary);
      this.$emit('changed', this.filterConfig(this.config));
    },
    updateLineWidth(value) {
      this.config.boundary.line_width = value;
      this.$emit('changed', this.filterConfig(this.config));
    },
    reverseFill() {
      this.config.boundary.fill_reversed = !(
        this.config.boundary && this.config.boundary.fill_reversed
      );
      this.$emit('changed', this.filterConfig(this.config));
    },
    updateOpacity(value) {
      this.config.boundary.fill_opacity = value / 100;
      this.$emit('changed', this.filterConfig(this.config));
    },
    fileIsValid(name) {
      return name.endsWith('.geojson') || name.endsWith('.json')
        || name.endsWith('gpx') || name.endsWith('kml') || name.endsWith('xml')
        || name.endsWith('txt');
    },
    dropFile(event) {
      const file = event.dataTransfer.files[0];
      if (event && file) this.processFile(file);
      this.dropped = false;
    },
    addFile(event) {
      const file = event.currentTarget.files[0];
      if (event && file) this.processFile(file);
    },
    updateGeometry() {
      if (this.geometryId) this.config.boundary.conf_id = this.geometryId;
      else delete this.config.boundary.conf_id;

      this.$emit('changed', this.filterConfig(this.config));
    },
    async processFile(file) {
      if (this.fileIsValid(file.name)) {
        this.error = '';
        if (file.size === 0) {
          this.error = 'Le fichier est vide !';
          return;
        }
        // MediumBlob is used to store geojson in base (16Mo). Used 15 here to be sure.
        if (file.size > 15000000) {
          this.error = `Le fichier est trop volumineux (${this.formatFileSize(file.size)})!`;
          return;
        }
        file.text().then(async (text) => {
          this.file = file;
          if (this.geometryId) {
            api.updateGeoJson(this.geometryId, file.name, text).then(
              // Success
              () => {
                this.success = 'Importation du nouveau fichier terminée avec succès !';
                setTimeout(() => { this.success = ''; }, 5000);
                this.$emit('changed', this.filterConfig(this.config));
              },
              // Error
              () => {
                this.error = 'Importation du nouveau fichier impossible ! Veuillez réessayer ultérieurement.';
                // We don't really what happen wrong. But we can conclude that the person want
                // to change is geometry. So we delete the actual geometry, just in case.
                this.deleteFile();
              },
            );
          } else {
            api.addGeoJson(file.name, text).then(
              // Success
              (response) => {
                this.geometryId = response.request.response.id;
                if (this.geometryId == null) {
                  this.file = null;
                  this.error = 'Importation du fichier impossible ! Veuillez réessayer ultérieurement.';
                } else {
                  this.success = 'Importation du fichier terminée avec succès !';
                  setTimeout(() => { this.success = ''; this.updateGeometry(); }, 5000);
                  this.$emit('changed', this.filterConfig(this.config));
                }
              },
              // Error
              () => {
                this.file = null;
                this.error = 'Importation du fichier impossible ! Veuillez réessayer ultérieurement.';
              },
            );
          }
        });
      } else {
        this.error = 'Type de fichier non supporté !';
      }
    },
    async deleteFile() {
      api.deleteGeoJson(this.geometryId).then(
        // Success
        () => {
          this.success = 'Suppression réussie avec succès !';
          setTimeout(() => { this.success = ''; this.updateGeometry(); }, 5000);
          this.file = null;
          this.geometryId = null;
          this.$emit('changed', this.filterConfig(this.config));
        },
        // Error
        () => {
          this.error = 'Une erreur s\'est produite lors de la suppression. Veuillez réessayer ultérieurement.';
        },
      );
      this.confirmDelete = false;
    },
    formatFileSize(bytes, decimals = 2) {
      if (bytes === 0) return 'vide';

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['o', 'Ko', 'Mo'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      // eslint-disable-next-line no-restricted-properties
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
  },
};
</script>

<style lang="scss">
.confirm-delete-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .confirm-text {
    text-align: center;
  }
}
.drop-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px lightgray dashed;
  border-radius: 1rem;
  padding: 1rem;
  width: 315px;
  height: 230px;

  &.has-file {
    border-style: solid;
  }
  .error-message {
    color: #E75239;
  }
  .success-message {
    color: green;
  }
  .upload {
    height: 100%;
    width: 100%;

    input {
      position: absolute;
      opacity: 0;
      z-index: 0;
      width: fit-content;
      height: 190px;

      &:hover {
        cursor: pointer;
      }
    }
    .dropZone {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;

      svg {
        height: 60%;

        .file {
          fill: grey;
        }
        .lines {
          fill: none;
          stroke: #FAFAFA;
          stroke-width: 3;
          stroke-linecap: round;
        }
      }
      p {
        margin: 0;
        text-align: center;
      }
      .msg {
        display: flex;

        .delete {
          margin-left: 0.5rem;
          width: 1.25rem;
          height: 1.25rem;
          fill: grey;
          z-index: 1;

          &:hover {
            fill: #E75239;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.title{
  font-family: Roboto,sans-serif;
  color: #e7523e;
  font-size: 17px !important;
}
.margin{
  margin: 10px 20px 30px 20px;
}
.v-slider__thumb-label{
  transform: translateY(95%) translateY(24px) translateX(-50%) rotate(225deg);

  span{
    transform: rotate(135deg);
  }
}
.invert-title{
  margin-right: 1.6rem;
  align-self: end;
  line-height: inherit;
}
.checkbox{
  margin-top: 14px;

  .v-input__slot{
    margin-bottom: 0 !important;
  }
  .v-messages{
    display: none;
  }
}
</style>
